<template>
    <v-card
        :dark="dark"
        :color="bgColor"
        @click="onCardClick(appointment)"
        hover height="230"
        class="kim-card secondary-card outlined hover d-flex flex-column"
        :style="{overflow: 'visible'}">

      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn light fab depressed absolute top right rounded x-small v-on="on" class="mt-6 mr-9">
              <event-status-icon :size="20" :event-status="appointment.event_status"/>
          </v-btn>
        </template>
        {{appointment.event_status.name}}
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn light fab depressed absolute top right rounded x-small v-on="on" class="mt-6">
            <v-icon>{{appointment.scheduled_from === 'internal' ? 'mdi-desktop-classic': 'mdi-web'}}</v-icon>
          </v-btn>
        </template>
        {{appointment.scheduled_from === 'internal' ? 'Agendado desde sistema' : `Agendado por ${clientSingular.toLowerCase()}`}}
      </v-tooltip>

        <v-card-title class="pa-2" v-if="appointment.client">
          <v-avatar color="secondary" size="30">
              <v-img :src="appointment.client.avatar || getFakeAvatar(appointment.client.gender)"></v-img>
          </v-avatar>
          <h2 style="max-width: 60%" class="ml-2 mr-2 body-1 font-weight-light text-truncate">
              {{`${appointment.client.first_name} ${appointment.client.last_name}`}}
          </h2>

        </v-card-title>

        <v-card-title class="pa-2" v-else>
            <v-avatar color="grey lighten-2" size="30">
                <v-icon color="secondary">fas fa-info-circle</v-icon>
            </v-avatar>
            <h2 class="ml-2 body-1 font-weight-light">Hora cancelada</h2>
        </v-card-title>

        <v-card-subtitle v-if="appointment.schedule.specialist" class="py-0 pl-7 pt-2 text-left">
            <v-icon size="12" left>fa-user-md</v-icon>
            <span class="caption">{{appointment.schedule.specialist.first_name}} {{appointment.schedule.specialist.last_name}}</span>
        </v-card-subtitle>

        <v-card-text class="text-left pa-2">

          <v-sheet class="text-left pa-1 chips-container">

                  <v-chip label readonly small color="secondary" class="ma-1">
                      <v-icon size="14" class="mr-2">fas fa-clock</v-icon>
                      {{appointment.time}}
                  </v-chip>

                  <template v-if="appointment.client">
                      <v-chip  label readonly small color="secondary" class="ma-1"   v-if="appointment.client.insurance_company">
                          <v-icon size="14" class="mr-2">fas fa-briefcase-medical</v-icon>
                          {{appointment.client.insurance_company.name}}
                      </v-chip>
                      <v-chip  label readonly small color="secondary" class="ma-1" >
                          <v-icon size="14" class="mr-2">{{appointment.client.isNew ? 'far fa-file' : 'far fa-file-alt'}}</v-icon>
                          {{appointment.client.isNew ? 'Nuevo' : 'Antiguo'}}
                      </v-chip>
                  </template>

            </v-sheet>

        </v-card-text>

        <v-card-actions class="mt-auto">

          <event-labels :labels="appointment.labels" dense />

          <v-spacer></v-spacer>

          <template v-if="appointment.client">

            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                    class="mr-1"
                    v-on="on"
                    light
                    small
                    v-if="appointment.event_status.id < 4"
                    @click.stop="onCancelClick(appointment)"
                >
                  <v-icon size="18" color="error">mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>Cancelar cita</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                    class="mr-1"
                    v-on="on"
                    light
                    small
                    @click.stop="onModifyClick(appointment)"
                    v-if="appointment.event_status.id < 3">
                  <v-icon color="secondary">
                    mdi-swap-horizontal
                  </v-icon>
                </v-btn>
              </template>
              <span>Cambiar cita</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                    class="mr-1"
                    v-on="on"
                    light
                    small
                    @click.stop="onArriveClick(appointment)"
                    v-if="appointment.event_status.id < 3">
                  <v-icon size="20" color="primary">
                    mdi-account-arrow-right-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Ingresar {{getLabel('commons.client.singular')}}</span>
            </v-tooltip>

          </template>

          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                    v-on="on"
                    light
                    small
                    @click.stop="!isPast && onAppointClick(appointment)"
                    v-if="appointment.event_status.id === 6">
                  <v-icon size="18"  color="primary">mdi-account-convert</v-icon>
                </v-btn>
              </template>
              <span>{{isPast ? 'Cita pasada, no es posible reagendar' : 'Citar a otro' + getLabel('commons.client.singular')}}</span>
            </v-tooltip>

          </template>
        </v-card-actions>


    </v-card>
</template>

<script>

    import EventStatusChip from '@/components/appointments/EventStatusChip'

    import {getLabel} from '@/utils/Institution'
    import {getFakeAvatar} from '@/utils/Common'
    import {getStatusColor} from '@/utils/ScheduleEvent'
    import EventLabels from "@/components/appointments/attention/EventLabels";
    import EventStatusIcon from "../../appointments/EventStatusIcon.vue";

    export default{
        props: {
          appointment: {
            type: Object,
            required: true
          }
        },
        data(){
            return {
                bgColor: '#f1f1f1',
                dark: false,
            }
        },
        mounted(){
            var vm = this
        },
        components: {EventStatusIcon, EventLabels, EventStatusChip},
        computed: {
            isPast(){
                var vm = this
                return vm.$moment(`${vm.appointment.date} ${vm.appointment.time}`).diff(
                        vm.$moment(),
                        'seconds'
                ) < 0
            },
            backgroundColor(){
              const vm = this
              return getStatusColor(vm.appointment.event_status.id)
            },
            statusIcon(){
                switch(this.appointment.event_status.id){
                    case 1:
                        return 'fas fa-info-circle'
                    case 2:
                        return 'fas fa-check-circle'
                    case 3:
                        return 'fas fa-hourglass-half'
                    default:
                        return 'fas fa-check-circle'
                }
            }
        },
        methods: {
            highlight(){
                var vm = this
                vm.bgColor = getStatusColor(vm.appointment.event_status_id)
                vm.dark = true
            },
            unhighlight(){
                var vm = this
                vm.bgColor = '#f1f1f1'
                vm.dark = false
            },
            onCardClick(appointment){
                this.$emit('click:card', appointment)
            },
            onCancelClick(appointment){
                this.$emit('click:cancel', appointment)
            },
            onArriveClick(appointment){
                this.$emit('click:arrive', appointment)
            },
            onModifyClick(appointment){
                this.$emit('click:modify', appointment)
            },
            onAppointClick(appointment){
                this.$emit('click:appointment', appointment)
            },
            getLabel,
            getFakeAvatar,
            getStatusColor
        },
        watch: {
            appointment(val){

                const vm = this

                if(val.highlighted && val.highlighted === true){
                    vm.highlight()
                }else{
                    vm.unhighlight()
                }

            }
        }
    }
</script>

<style scoped>

    .chips-container{
        border: 2px solid rgba(var(--background-light), .3) !important;
        background: none !important;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
    }

    >>>.v-card{
        transition: background-color 1s !important;
       }

    .event-card{
        border: 2px solid !important;
        border-color: rgba(0,0,0,1);
        border-radius: 5px;
        transition: 1s all
    }

</style>
